import lodash from "lodash";
import { abRepopulate, setAbErrMsg } from "./AgentsBioUtils";

// TYPES

export const AI_DESC_AB_UPDATE_ORGANIZATION = "AI_DESC_AB_UPDATE_ORGANIZATION";
export const AI_DESC_AB_UPDATE_DETAILS = "AI_DESC_AB_UPDATE_DETAILS";
export const AI_DESC_AB_UPDATE_RADIO_SELECT = "AI_DESC_AB_UPDATE_RADIO_SELECT";
export const AI_DESC_AB_UPDATE_PRONOUN = "AI_DESC_AB_UPDATE_PRONOUN";
export const AI_DESC_AB_HANDLE_PRONOUN_DROPDOWN_OPEN =
    "AI_DESC_AB_HANDLE_PRONOUN_DROPDOWN_OPEN";
export const AI_DESC_AB_CLEAR = "AI_DESC_AB_CLEAR";
export const AI_DESC_AB_UPDATE_BIO = "AI_DESC_AB_UPDATE_BIO";
export const AI_DESC_AB_UPDATE_BIO_ISEDITING =
    "AI_DESC_AB_UPDATE_BIO_ISEDITING";
export const AI_DESC_AB_GENERATE_BIO = "AI_DESC_AB_GENERATE_BIO";
export const AI_DESC_AB_REGENERATE_BIO = "AI_DESC_AB_REGENERATE_BIO";
export const AI_DESC_AB_HANDLE_ACTION_BIO = "AI_DESC_AB_HANDLE_ACTION_BIO";
export const AI_DESC_AB_FETCH_BIO = "AI_DESC_AB_FETCH_BIO";
export const AI_DESC_AB_UNDO_BIO = "AI_DESC_AB_UNDO_BIO";
export const AI_DESC_AB_UPDATE_PAGE_TYPE = "AI_DESC_AB_UPDATE_PAGE_TYPE";
export const AI_DESC_AB_UPDATE_ACTION_BIO = "AI_DESC_AB_UPDATE_ACTION_BIO";
export const AI_DESC_AB_HANDLE_SEVER_BUSY_POPUP =
    "AI_DESC_AB_HANDLE_SEVER_BUSY_POPUP";
export const AI_DESC_AB_HANDLE_REPOPULATE_BIO =
    "AI_DESC_AB_HANDLE_REPOPULATE_BIO";


// ACTIONS

export const handleAbPronounDdOpen = (payload) => ({
    type: AI_DESC_AB_HANDLE_PRONOUN_DROPDOWN_OPEN,
    payload,
});

export const updateAbPronoun = (payload) => ({
    type: AI_DESC_AB_UPDATE_PRONOUN,
    payload,
});

export const updateAbRadioSelect = (payload) => ({
    type: AI_DESC_AB_UPDATE_RADIO_SELECT,
    payload,
});

export const fetchAbDesc = (payload) => ({
    type: AI_DESC_AB_FETCH_BIO,
    payload,
});

export const handleAbSeverBusyPopup = (payload) => ({
    type: AI_DESC_AB_HANDLE_SEVER_BUSY_POPUP,
    payload,
});

export const updateActionAbDesc = (payload) => ({
    type: AI_DESC_AB_UPDATE_ACTION_BIO,
    payload,
});

export const updateAbOrganization = (payload) => ({
    type: AI_DESC_AB_UPDATE_ORGANIZATION,
    payload,
});

export const updateAbDetails = (payload) => ({
    type: AI_DESC_AB_UPDATE_DETAILS,
    payload,
});

export const updateAbDesc = (payload) => ({
    type: AI_DESC_AB_UPDATE_BIO,
    payload,
});

export const updateAbDescIsEditing = (payload) => ({
    type: AI_DESC_AB_UPDATE_BIO_ISEDITING,
    payload,
});

export const handleAbDescUndo = (payload) => ({
    type: AI_DESC_AB_UNDO_BIO,
    payload,
});

export const updateAbPageType = (payload) => ({
    type: AI_DESC_AB_UPDATE_PAGE_TYPE,
    payload,
});

export const handleRepopulateAb = (payload) => ({
    type: AI_DESC_AB_HANDLE_REPOPULATE_BIO,
    payload,
});

export const clearAbDetails = (payload) => ({
    type: AI_DESC_AB_CLEAR,
    payload,
});

// Actions to trigger saga generators

export const generateAbDesc = (payload) => ({
    type: AI_DESC_AB_GENERATE_BIO,
    payload,
});

export const regenerateAbDesc = (payload) => ({
    type: AI_DESC_AB_REGENERATE_BIO,
    payload,
});

export const handleActionAbDesc = (payload) => ({
    type: AI_DESC_AB_HANDLE_ACTION_BIO,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    order_id: `${Date.now() + Math.floor(Math.random() * 100)}`,
    radioCont:{
        typeOfBio:{
            title:"1. Type of the bio",
            optionList: [
                "Comprehensive",
                "Short",
            ],
            selectedItem: "Comprehensive",
        },
        pointOfView:{
            title:"2. Point of view",
            optionList: [
                "First person",
                "Third person",
            ],
            selectedItem: "First person",
        },
    },
    preferredPronoun: {
        title: "Select pronoun",
        defaultTitle: "Select pronoun",
        dropDownList: [
            "Select pronoun",
            "he/him",
            "she/her",
            "they/them",
            "xe/xem",
            "ze/zir",
        ],
        selectedItem: "",
        isOpen: false,
    },
    organization: "",
    details:{
        expertiseAndSpecialites:{
            title:"4. Expertise & specialties",
            data:"",
            placeholder:"Mention your working location, agent type, education, certifications, skills and languages spoken.",
            isrequired:true,
            additionalInfo:"",
        },
        credentialsAndAccomplishments:{
            title:"5. Credentials & accomplishments",
            data:"",
            placeholder:"Mention your experience, number of families/sales you have assisted, awards or recognition that you received.",
            isrequired:false,
            additionalInfo:"Skip this section if you are new to the profession",
        },
        lifeStory:{
            title:"6. Life story",
            data:"",
            placeholder:"Write in short about your family, spouse & kids, beginning of your career, goals/values that you follow & your hobbies.",
            isrequired:false,
            additionalInfo:"",
        },
        otherDetails:{
            title:"7. Any other details ",
            data:"",
            placeholder:"Any other relevant data that you want to include in your bio.",
            isrequired:false,
            additionalInfo:"",
        },
    },
    bioGenerated: [
        // {
        //     status: "Just now",
        //     generatedDesc:
        //         "application\n\n\n\nHello, \n\nI am writing to inform you that I am going to be taking a leave of absence from work. I will be gone for two weeks starting on Monday. Thank you for understanding and I hope everything goes well while I'm away. \n\nSincerely, \n[Your Name]",
        //         editedDesc: "",
        //     isEditing: false,
        //     isEdited: false,
        //     liked: null,
        //     generated_at: Date.now(),
        // },
    ],
    isGenBioBtnHidden: false,
    isGenBioBtnDisabled: true,
    isBioGenerating: false,
    errMsg: "Please fill the required fields.",
    repopulate: false,
    pageType: "Agent's Bio",
    popups: {
        busyServer: {
            show: false,
        },
    },
};

const AgentsBioReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case AI_DESC_AB_CLEAR: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${
                Date.now() + Math.floor(Math.random() * 100)
            }`;
            return { ...temp_state };
        }
        case AI_DESC_AB_UPDATE_DETAILS: {
            const { details,detailType } = action.payload;
            let temp_state = { ...state };
            temp_state['details'][detailType]['data'] = details;
            temp_state.isGenBioBtnHidden = false;
            setAbErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_HANDLE_PRONOUN_DROPDOWN_OPEN: {
            const { isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state.preferredPronoun.isOpen = isOpen;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_PRONOUN: {
            const { pronoun } = action.payload;
            let temp_state = { ...state };
            let pronounObj = temp_state['preferredPronoun'];
            if (pronounObj["defaultTitle"] == pronoun) {
                pronounObj["selectedItem"] = "";
                pronounObj["title"] = pronounObj["defaultTitle"];
            } else {
                pronounObj["selectedItem"] = pronoun;
                pronounObj["title"] = pronoun;
            }
            temp_state.isGenBioBtnHidden = false;
            setAbErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_ORGANIZATION: {
            const { org } = action.payload;
            let temp_state = { ...state };
            temp_state.organization = org;
            temp_state.isGenBioBtnHidden = false;
            setAbErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_RADIO_SELECT: {
            const { radioKey,opt } = action.payload;
            let temp_state = { ...state };
            let radioObj = temp_state['radioCont'][radioKey];
            radioObj['selectedItem']=opt
            temp_state.isGenBioBtnHidden = false;
            setAbErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }

        case AI_DESC_AB_UPDATE_BIO: {
            const { descInd, desc } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.bioGenerated;
            emailGen[descInd]["editedDesc"] = desc;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_BIO_ISEDITING: {
            const { isEditing, descInd } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.bioGenerated;
            emailGen[descInd]["isEditing"] = isEditing;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_FETCH_BIO: {
            let temp_state = { ...state };
            const { emails } = action.payload;
            temp_state.isGenBioBtnHidden = true;
            temp_state.bioGenerated = emails;
            temp_state["isBioGenerating"] = false;
            temp_state["pageType"] = "Generated Section";
            temp_state.repopulate = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_ACTION_BIO: {
            const { descInd, actionInfo, isEdited } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.bioGenerated;
            Object.keys(actionInfo).forEach((actKey) => {
                emailDesc[descInd][actKey] = actionInfo[actKey];
            });
            emailDesc[descInd]["isEdited"] = isEdited;
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UNDO_BIO: {
            const { descInd } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.bioGenerated;
            emailDesc[descInd]["editedDesc"] =
                emailDesc[descInd]["description_generated"];
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_GENERATE_BIO: {
            let temp_state = { ...state };
            temp_state["isBioGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_REGENERATE_BIO: {
            let temp_state = { ...state };
            temp_state["isBioGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_UPDATE_PAGE_TYPE: {
            const { pageType } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType = pageType;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_HANDLE_REPOPULATE_BIO: {
            const { data } = action.payload;
            let temp_state = { ...state };
            abRepopulate(temp_state, data);
            setAbErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_AB_HANDLE_SEVER_BUSY_POPUP: {
            let temp_state = { ...state };
            const { isShow } = action.payload;
            temp_state.popups.busyServer.show = isShow;
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default AgentsBioReducer;
